// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.auto-logout-page .settings-modal-header {
  position: relative;
  justify-content: center;
}

.auto-logout-page .back-button {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}
.auto-logout-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.auto-logout-content {
  padding: 0 24px;
  flex-grow: 1;
  overflow-y: auto;
}

.auto-logout-form {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.auto-logout-form .form-group {
  margin-top: 24px;
}

/* Style number input spinners */
.auto-logout-form .form-input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}

.auto-logout-form .form-input[type="number"]::-webkit-outer-spin-button,
.auto-logout-form .form-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: inner-spin-button;
  opacity: 1;
  height: 100%;
  cursor: pointer;
}

.auto-logout-footer {
  margin-top: auto;
  padding-bottom: 24px;
  display: flex;
  justify-content: flex-end;
}

.auto-logout-footer .settings-modal-button.primary {
  background-color: var(--netsfere-red);
}
.auto-logout-footer .settings-modal-button.primary:hover:not(:disabled) {
  background-color: rgb(195, 60, 75);
}

.auto-logout-footer .settings-modal-button {
  min-width: 120px;
}

.auto-logout-footer .settings-modal-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.success-message {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  font-size: 14px;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/AutoLogoutPage.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,0BAA0B,EAAE,YAAY;AAC1C;;AAEA;;EAEE,qCAAqC;EACrC,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["\n.auto-logout-page .settings-modal-header {\n  position: relative;\n  justify-content: center;\n}\n\n.auto-logout-page .back-button {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.auto-logout-page {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.auto-logout-content {\n  padding: 0 24px;\n  flex-grow: 1;\n  overflow-y: auto;\n}\n\n.auto-logout-form {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.auto-logout-form .form-group {\n  margin-top: 24px;\n}\n\n/* Style number input spinners */\n.auto-logout-form .form-input[type=\"number\"] {\n  -moz-appearance: textfield; /* Firefox */\n}\n\n.auto-logout-form .form-input[type=\"number\"]::-webkit-outer-spin-button,\n.auto-logout-form .form-input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: inner-spin-button;\n  opacity: 1;\n  height: 100%;\n  cursor: pointer;\n}\n\n.auto-logout-footer {\n  margin-top: auto;\n  padding-bottom: 24px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.auto-logout-footer .settings-modal-button.primary {\n  background-color: var(--netsfere-red);\n}\n.auto-logout-footer .settings-modal-button.primary:hover:not(:disabled) {\n  background-color: rgb(195, 60, 75);\n}\n\n.auto-logout-footer .settings-modal-button {\n  min-width: 120px;\n}\n\n.auto-logout-footer .settings-modal-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.success-message {\n  margin-top: 8px;\n  padding: 8px 12px;\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 4px;\n  font-size: 14px;\n  animation: fadeIn 0.3s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
